import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './Skeleton.scss';

function SkeletonImage ({ circle, height, width }) {

	const className = classNames('Skeleton', 'Skeleton--image', circle && 'Skeleton--circle');

	return <div className={className} style={{ height, width }} />;

}

SkeletonImage.defaultProps = {
	circle: false,
	height: undefined,
	width: undefined
};

SkeletonImage.propTypes = {
	circle: PropTypes.bool,
	height: PropTypes.number,
	width: PropTypes.number
};

export default SkeletonImage;
